const ptBR = {
  "commom.confirm.delete": "Tem certeza de que deseja excluir?",
  "common.accept": "Aceitar",
  "common.access.control": "Controle de Acesso",
  "common.action.not.allowed": "Ação não Permitida",
  "common.action.not.allowedMessage": "Você não tem permissão para realizar esta ação.",
  "common.action": "Ação",
  "common.actions": "Ações",
  "common.active": "Ativo",
  "common.activity": "Atividade",
  "common.add.to.filter": "Adicionar ao filtro",
  "common.add.to.list": "Adicionar à lista",
  "common.add": "Adicionar",
  "common.administrators": "Administradores",
  "common.all": "Todos",
  "common.all.devices": "Todos os Dispositivos",
  "common.allow.all": "Permitir Todos",
  "common.allow": "Permitir",
  "common.allowed": "Permitido",
  "common.alloweds": "Permitidos",
  "common.alreadyExists": "Já existe",
  "common.always": "Sempre",
  "common.any": "Qualquer",
  "common.api_settings": "Configuração de APIs",
  "common.apis": "APIs",
  "common.application": "Aplicação",
  "common.apply": "Aplicar",
  "common.archive": "Arquivo",
  "common.at.day": "Dia",
  "common.at.hours": "às",
  "common.attack": "Ataque",
  "common.audit.log": "Log de Auditoria",
  "common.audit": "Auditoria",
  "common.auditor": "Auditor",
  "common.auth.servers": "Servidores de Autenticação",
  "common.auth": "Autenticado",
  "common.authenticated": "Autenticado",
  "common.authentication.required": "Campo MFA é obrigatório",
  "common.authentication": "Autenticação",
  "common.authorization.settings": "Configuração de Autorização",
  "common.back.to.home": "Voltar para Casa",
  "common.back.to.previous": "Voltar para Anterior",
  "common.back": "Voltar",
  "common.backup": "Backup",
  "common.backups": "Backups",
  "common.balancing": "Balanceamento",
  "common.bandwidth": "Bandwidth",
  "common.blacklist": "Endereços Bloqueados",
  "common.block_all": "Bloquear Todos",
  "common.block": "Bloquear",
  "common.ha": "High Availabilty Habilitado",
  "common.blocked.access": "Acesso Bloqueado",
  "common.blocked": "Bloqueado",
  "common.blockeds": "Bloqueados",
  "common.bytes.received": "Bytes Recebidos",
  "common.bytes.sent": "Bytes Enviados",
  "common.bytes.total": "Bytes Total",
  "common.bytes": "Bytes",
  "common.cancel.action": "Cancelar Ação",
  "common.cancel": "Cancelar",
  "common.category": "Categoria",
  "common.certificate.remote": "CA Remota",
  "common.certificate": "Certificado",
  "common.certificates": "Certificados",
  "common.change": "Alterar",
  "common.city": "Cidade",
  "common.clear": "Limpar",
  "common.client": "Cliente",
  "common.clone.error": "Error ao clonar",
  "common.clone.success": "Clonado com sucesso",
  "common.clone": "Clonar",
  "common.close": "Fechar",
  "common.collapse": "Recolher",
  "common.community": "Comunidade de Device",
  "common.company": "Companhia",
  "common.completed": "Completo",
  "common.conditions": "Condições",
  "common.config": "Configuração",
  "common.configure": "Configurar",
  "common.confirm.action": "Confirmar Ação",
  "common.confirm.changes": "Confirmar Alterações",
  "common.confirm.Delete": "Confirmar Exclusão",
  "common.confirm.ok": "Confirmar",
  "common.confirmation": "Confirmação",
  "common.connect": "Conectado",
  "common.connection.error": "Erro de Conexão",
  "common.connection.lost.message": "A conexão com o servidor foi perdida. Por favor, verifique sua conexão com a internet e tente novamente.",
  "common.connection.lost": "Conexão Perdida",
  "common.connection": "Conexão",
  "common.connections": "Conexões",
  "common.continue": "Continuar",
  "common.controls": "Controles",
  "common.copied": "Copiado",
  "common.copy": "Copiar",
  "common.country": "País",
  "common.create.name": "Criar {name}",
  "common.create": "Criar",
  "common.created": "Criado",
  "common.custom-signature": "Assinatura Customizada",
  "common.customize": "Customizar",
  "common.dashboard": "Painel de Controle",
  "common.data.Loading.error": "Erro ao Carregar Dados",
  "common.data.Loading.errorMessage": "Houve um problema ao carregar os dados. Por favor, tente novamente.",
  "common.date": "Data",
  "common.days": "Dias",
  "common.decline": "Recusar",
  "common.declined": "Recusado",
  "common.default": "Default",
  "common.del.to.list": "Remover da lista",
  "common.delete.confirmation.multiple": "Tem certeza que deseja excluir os itens selecionados?",
  "common.delete.confirmation": "Tem certeza que deseja excluir?",
  "common.delete.name": "Excluir {name}",
  "common.delete.select": "Excluir selecionados",
  "common.delete.success": "Removido com sucesso",
  "common.delete": "Excluir",
  "common.deleted": "{name} deletado com sucesso",
  "common.denied": "Negados",
  "common.deny_all": "Recusar Todos",
  "common.deny": "Recusar",
  "common.deploy": "Deploy",
  "common.description": "Descrição",
  "common.deselect.all": "Desselecionar Todos",
  "common.destination": "Destino",
  "common.details": "Detalhes",
  "common.devComm": "Comunidade de Device",
  "common.device": "Device",
  "common.deviceLogger": "Device/Logger",
  "common.devin": "Device",
  "common.devTemplate": "Template de Device",
  "common.dhcp": "DHCP",
  "common.diff": "Diferencial",
  "common.directory": "Diretório",
  "common.disable_all": "Desabilitar Todos",
  "common.disable.all": "Desativar Todos",
  "common.disable": "Desabilitar",
  "common.disabled.success": "Desabilitado com sucesso",
  "common.disabled": "Desabilitado",
  "common.disableds": "Desabilitados",
  "common.disc": "Disco",
  "common.discard.changes": "Descartar Alterações",
  "common.disclaimer.login.title": "Termo de Responsabilidade de Login",
  "common.disclaimer": "Termo de responsabilidade",
  "common.disk": "disco",
  "common.dns_server": "Servidor DNS",
  "common.dns": "DNS",
  "common.dnsServer": "Servidor DNS",
  "common.dnssuffix": "Sufixo DNS",
  "common.domain": "Domínio",
  "common.done": "Concluído",
  "common.dont.permission.clone": "Você não tem permissão para clonar esse registro.", 
  "common.dont.permission.delete": "Você não tem permissão para deletar esse registro.", 
  "common.dont.permission.edit": "Você não tem permissão para editar esse registro.",  
  "common.dont.permission.page": "Você não tem permissão para acessar essa página.",
  "common.dont.permission": "Você não tem permissão para executar essa ação.",
  "common.dst": "Destino",
  "common.duration": "Duração",
  "common.edit": "Editar",
  "common.email.report": "Enviar Relatório por E-mail",
  "common.email": "E-mail",
  "common.enable.all": "Ativar Todos",
  "common.enable": "Habilitar",
  "common.enabled": "Habilitado",
  "common.english": "Inglês",
  "common.error.character": "Caractere inválido.",
  "common.error.email": "{name} deve ser um email válido.",
  "common.error.fetch": "Erro ao buscar os dados.",
  "common.error.file.notfound": "Arquivo não encontrado",
  "common.error.invalid.format.core.max": "Valor acima do limite, máximo permitido",
  "common.error.invalid.format.core.min": "Valor abaixo do limite, mínimo permitido",
  "common.error.invalid.format": "Formato inválido",
  "common.error.invalid.value": "Valor inválido",
  "common.error.invalid": "{name} é inválido",
  "common.error.min.character": "O campo deve ter no mínimo {number} caracteres.",
  "common.error.network": "Erro de rede!",
  "common.error.required.advancedSettings": "O valor é obrigatório",
  "common.error.required.ip.forwarding": "IP é obrigatório",
  "common.error.required": "{name} é obrigatório",
  "common.error.saml.service.name": "Nome de Serviço SAML é obrigatório",
  "common.error.snap.version": " Versão do Snap não suportada",
  "common.error.url.fail": "Url inválida.",
  "common.error.url.https": "Está URL deve ser do tipo https.",
  "common.error.url": "{name} deve ser um url válido.",
  "common.error.version": "Versão não suportada",
  "common.error": "Erro",
  "common.established": "Estabelecido",
  "common.event": "Evento",
  "common.exception": "Exceção",
  "common.expand": "Expandir",
  "common.expires": "Expira em (anos)",
  "common.failed": "Falha",
  "common.filial": "Filial",
  "common.filter": "Filtro",
  "common.filters": "Filtros",
  "common.firewall": "Firewall",
  "common.first": "Primeiro",
  "common.gateway": "Gateway",
  "common.general": "Geral",
  "common.generic.error.message": "Ocorreu um erro. Por favor, tente novamente mais tarde.",
  "common.generic.error": "Erro Genérico",
  "common.github": "GitHub",
  "common.group": "Grupo",
  "common.groups": "Grupos",
  "common.hide": "Ocultar",
  "common.high.availability": "Alta Disponibilidade",
  "common.high": "Alto",
  "common.highAvailability": "High Availability",
  "common.hits": "Hits",
  "common.host": "Host",
  "common.hostname": "Nome do Host",
  "common.hours": "Horas",
  "common.id": "ID",
  "common.identification": "Identificação",
  "common.identity.provider": "Provedor de Identidade",
  "common.idle": "Ociosidade",
  "common.import-file": "Importar arquivo",
  "common.import": "Importar {name}",
  "common.inactive": "Inativo",
  "common.information": "Informação",
  "common.informations": "Informações",
  "common.initial.space.error": "Espaço inicial não é permitido",
  "common.inspection": "Inspeção",
  "common.integrated": "Integrado",
  "common.integration.settings": "Configuração de Integração",
  "common.interface": "Interface",
  "common.interfaces": "Interfaces",
  "common.invalid.fields": "Campos inválidos",
  "common.invalid.form": "Por favor revise este formulário!",
  "common.invalid.Format.message": "O formato inserido é inválido. Por favor, insira um formato válido.",
  "common.invalid.Format": "Formato Inválido",
  "common.invalid.input.message": "Por favor, forneça uma entrada válida.",
  "common.invalid.input": "Entrada Inválida",
  "common.invalid.Request": "Requisição Inválida",
  "common.invalid.value": "Valor inválido!",
  "common.ip": "IP",
  "common.ipAddress": "Endereço IP",
  "common.ipExample": "1.1.1.1",
  "common.ips": "IP's",
  "common.items.not.found": "Nenhum ítem encontrado",
  "common.jitter": "Jitter",
  "common.key": "Chave",
  "common.language": "Idioma",
  "common.latency": "Latência",
  "common.Lease": "Leases",
  "common.license.expires.at": "Licença irá expirar em:",
  "common.license": "Licença",
  "common.limit.profile": "Limite de perfis criados.",
  "common.linkedin": "LinkedIn",
  "common.list": "Lista",
  "common.loading": "Carregando",
  "common.local": "Local",
  "common.logger": "Logger",
  "common.logging": "Logging",
  "common.login.form.email.required": "E-mail é obrigatório",
  "common.login.form.email": "Endereço de E-mail",
  "common.login.form.forgot": "Esqueceu a senha?",
  "common.login.form.password.required": "Senha é obrigatória",
  "common.login.form.password": "Senha",
  "common.login.form": "Acesse sua conta",
  "common.login": "Login",
  "common.logs": "Logs",
  "common.logtype": "Tipo de log",
  "common.low": "Baixo",
  "common.mac": "MAC",
  "common.malicious": "IP Malicioso",
  "common.malware": "Malware",
  "common.manager.delete.group.message.withdevice": "Tem certeza que deseja excluir o grupo? Esta operação não pode ser revertida.",
  "common.manager.delete.group.message": "Tem certeza que deseja excluir o grupo?",
  "common.mask": "Máscara",
  "common.master": "Matriz",
  "common.max": "Max",
  "common.medium": "Médio",
  "common.minFile": "Tamanho mínimo do arquivo (MB)",
  "common.minutes": "Minutos",
  "common.mode": "Modo",
  "common.model": "Modelo",
  "common.modules": "Módulos",
  "common.months": "Meses",
  "common.multifactor.acronym": "MFA",
  "common.multifactor.active": "Identificação por dois fatores",
  "common.multifactor.authentication": "Autenticação multifator",
  "common.multifactor.validate": "Usuário com chave cadastrada",
  "common.name.already.exists": "Nome de perfil já existe!",
  "common.name": "Nome",
  "common.network": "Rede",
  "common.new": "Novo",
  "common.next": "Próximo",
  "common.no.results.found.message": "Não foram encontrados resultados para a sua busca.",
  "common.no.results.found": "Nenhum Resultado Encontrado",
  "common.not.Authorized": "Não Autorizado",
  "common.no": "Não",
  "common.no.group": "Nenhum Grupo",
  "common.none": "Nenhum",
  "common.nothing.delete": "Nenhum item a ser deletado",
  "common.notifications": "Notificações",
  "common.ntp.server": "Servidor NTP",
  "common.object.address": "Endereço",
  "common.object.content": "Conteúdo",
  "common.object.dictionary": "Dicionário",
  "common.object.schedule": "Agendamento",
  "common.object.service": "Serviço",
  "common.object.time": "Tempo",
  "common.ok": "Ok",
  "common.operation.failed.message": "A operação solicitada falhou. Por favor, tente novamente.",
  "common.operation.failed": "Operação Falhou",
  "common.organization": "Empresa",
  "common.overview": "Visão Geral",
  "common.packages.combo": "Pacotes de Políticas",
  "common.packages.received": "Packages Recebidos",
  "common.packages.sent": "Packages Enviados",
  "common.packages.total": "Packages Total",
  "common.packages": "Pacotes",
  "common.packet.logger": "Packet Logger",
  "common.packet.loss": "Perda de Pacotes",
  "common.packets": "Packets",
  "common.page.not.found.message": "A página que você está procurando não pôde ser encontrada.",
  "common.page.not.found": "Página Não Encontrada",
  "common.page": "Página",
  "common.passive": "Passivo",
  "common.password": "Senha",
  "common.paste.here": "Cole Aqui",
  "common.pcap": "PCAP",
  "common.perHour": "por hora",
  "common.perMinute": "por minuto",
  "common.permission.Denied": "Permissão Negada",
  "common.perSecond": "por segundo",
  "common.policy": "Política",
  "common.polPackage": "Pacote de Política",
  "common.port": "Porta",
  "common.portuguese": "Português",
  "common.position": "Posição",
  "common.prefixPcap": "Prefixo do arquivo",
  "common.prev": "Anterior",
  "common.proceed": "Prosseguir",
  "common.processes": "Processos",
  "common.profile_filesize": "Tamanho máximo do arquivo (MB)",
  "common.profile.appcontrol": "Perfil de Application Control",
  "common.profile.atp": "Perfil de Threat Protection",
  "common.profile.ips": "Perfil de Intrusion Prevention",
  "common.profile.sdwan": "Perfil SD-WAN",
  "common.profile.ssl": "Perfil de Inspeção SSL",
  "common.profile.webfilter.inUse": "Web Filter em Uso",
  "common.profile.webfilter": "Perfil de Web Filter",
  "common.profile": "Perfil",
  "common.profiles": "Perfis",
  "common.progress": "Progresso",
  "common.protocol": "Protocolo",
  "common.protocols": "Protocolos",
  "common.provisioning": "Provisionamento",
  "common.quantity": "Quantidade",
  "common.quarantine": "Quarentena",
  "common.read": "Leitura",
  "common.reason": "Razão",
  "common.record": "registro",
  "common.records": "registros",
  "common.refresh": "Atualizar",
  "common.reject": "Rejeitar",
  "common.relevance": "Relevância",
  "common.reload.page": "Recarregar a Página",
  "common.reload": "Recarregar",
  "common.remote": "Remoto",
  "common.remove": "Remover",
  "common.required.field": "Campo obrigatório",
  "common.reset": "Redefinir",
  "common.resource.not.found": "Recurso Não Encontrado",
  "common.restore": "Restaurar",
  "common.retry": "Tentar Novamente",
  "common.risk": "Risco",
  "common.routes": "Rotas",
  "common.rule": "Regra",
  "common.save.changes": "Salvar Alterações",
  "common.save.error": "Erro ao salvar!",
  "common.save.success": "Salvo com sucesso",
  "common.save": "Salvar",
  "common.scheduled": "Agendado",
  "common.search": "Busca",
  "common.seconds": "segundo(s)",
  "common.secret": "Segredo",
  "common.security": "Segurança",
  "common.select.all": "Selecionar Todos",
  "common.select.device.logger": "Selecione Device/Logger",
  "common.select.option": "Selecionar Opção",
  "common.select.time.end": "Selecione a hora final",
  "common.select.time.ini": "Selecione a hora inicial",
  "common.select": "Selecionar",
  "common.selected.objects": "{count} selecionados",
  "common.selected": "Selecionado",
  "common.server.error": "Erro do Servidor",
  "common.server": "Servidor",
  "common.servers": "Servidores",
  "common.service": "Serviço",
  "common.services": "Serviços",
  "common.session.Expired.message": "Sua sessão expirou. Por favor, faça login novamente.",
  "common.session.Expired": "Sessão Expirada",
  "common.sessions": "Sessões",
  "common.settings": "Configurações",
  "common.share": "Compartilhamento",
  "common.show.all": "Visualizar todos",
  "common.show": "Mostrar",
  "common.sid": "SID",
  "common.simultaneous.transfers": "Transferências Simultâneas",
  "common.site": "Site",
  "common.size": "Tamanho",
  "common.socialmedias": "Redes Sociais",
  "common.something.Went.Wrong": "Algo Deu Errado",
  "common.source": "Origem",
  "common.sources": "Origens",
  "common.src": "Origem",
  "common.sso": "SSO",
  "common.standalone": "Remoto",
  "common.start": "Iniciar",
  "common.state": "Estado",
  "common.static.routing": "Roteamento Estático",
  "common.status": "Status",
  "common.stop": "Parar",
  "common.storage": "Armazenamento",
  "common.storages": "Armazenamentos",
  "common.success": "Sucesso",
  "common.sync": "Sincronização",
  "common.system.updates": "Updates",
  "common.system": "Sistema",
  "common.task": "Task",
  "common.template.name": "Nome do Template",
  "common.template": "Template",
  "common.templates.combo": "Template de Device",
  "common.templates": "Templates de Device",
  "common.text.too.long.70c": "O valor não deve ser maior que 70 caracteres",
  "common.text.too.long": "Limite máximo de caracteres atingido",
  "common.threat": "Ameaça",
  "common.time.conection": "Tempo de Conexão",
  "common.time.system": "Hora do Sistema",
  "common.time": "Tempo",
  "common.timeout.error": "Erro de Tempo Limite",
  "common.timezone": "Fuso horário",
  "common.toggle": "Alternar",
  "common.top": "Top",
  "common.total": "Total",
  "common.traffic.distribution": "Distribuição de Tráfego",
  "common.traffic": "Tráfego",
  "common.transparent": "Transparente",
  "common.try.again.later": "Tente Novamente Mais Tarde",
  "common.type": "Tipo",
  "common.unableto.perform.Operation.message": "Não foi possível realizar a operação solicitada. Tente novamente mais tarde.",
  "common.unableto.perform.Operation": "Incapaz de Realizar a Operação",
  "common.unavaible": "Não disponível",
  "common.unblock": "Desbloquear",
  "common.unblocked": "Desbloqueado",
  "common.unexpected.Behaviour.message": "Ocorreu um comportamento inesperado. Por favor, tente novamente.",
  "common.unexpected.Behaviour": "Comportamento Inesperado",
  "common.unexpected.error": "Erro Inesperado",
  "common.unexpected.Response": "Resposta Inesperada",
  "common.unit": "Unidade Organizacional",
  "common.unknown": "Desconhecido",
  "common.unlimited": "Ilimitado",
  "common.update": "Atualizar",
  "common.updates": "Atualizações",
  "common.uptime": "Tempo de Atividade",
  "common.used": "Uso",
  "common.user.agent": "Plataforma",
  "common.user": "Usuário",
  "common.users.profiles": "Perfis de Usuários",
  "common.users": "Usuários",
  "common.uuid": "UUID",
  "common.values": "Valores",
  "common.vdom": "Domínios Virtuais",
  "common.version": "Versão",
  "common.view": "Visualizar",
  "common.virtualAddress": "Endereço Virtual",
  "common.virtualDomain": "Domínio Virtual",
  "common.vpn": "VPN",
  "common.warning_all": "Alertar Todos",
  "common.warning": "Atenção",
  "common.whitelist": "Endereços Liberados",
  "common.wizard.admin.repass.mismatch": "As senhas não conferem",
  "common.wizard.network.dns.error": "Servidor DNS {number} é obrigatório",
  "common.wizard.network.dns": "Servidor DNS {number}",
  "common.workers": "Workers",
  "common.working": "Processando...",
  "common.write": "Escrita",
  "common.years": "Anos",
  "common.yes": "Sim",
  "common.zone": "Zona",
  "error.badGateway": "Gateway incorreto ou temporariamente indisponível.",
  "error.conflict": "Conflito. Dados duplicados.",
  "error.contentValidation": "Erro de validação de conteúdo.",
  "error.continue": "Continuando...",
  "error.createdRequest": "Requisição criada com sucesso.",
  "error.default": "Erro Padrão",
  "error.defaultError": "Ocorreu um erro inesperado.",
  "error.defaultErrorWithCode": "Erro {{code}}. Ocorreu um erro inesperado.",
  "error.file.notfound.message": "O arquivo solicitado não pôde ser encontrado.",
  "error.file.notfound": "Arquivo Não Encontrado",
  "error.file.upload.failed.message": "O envio do arquivo falhou. Por favor, tente novamente.",
  "error.file.upload.failed": "Falha no Envio do Arquivo",
  "error.forbidden": "Acesso proibido. Você não tem permissão para esta ação.",
  "error.gatewayTimeout": "Tempo de resposta excedido. Tente novamente mais tarde.",
  "error.generic": "Erro Genérico",
  "error.gone": "Recurso não mais disponível.",
  "error.internal.server.error": "Erro interno do servidor. Tente novamente mais tarde.",
  "error.invalid.credentials.message": "As credenciais fornecidas são inválidas. Tente novamente.",
  "error.invalid.credentials": "Credenciais Inválidas",
  "error.invalid.input": "Entrada Inválida",
  "error.legal.access.denied": "Acesso ao recurso negado por motivos legais.",
  "error.moved.permanently": "Página movida permanentemente. Redirecionando...",
  "error.moved.temporarily": "Página movida temporariamente. Redirecionando...",
  "error.network.rrror": "Erro de rede. Verifique sua conexão à Internet.",
  "error.no.internet.connection": "Sem Conexão com a Internet",
  "error.no.content": "Requisição bem-sucedida, mas sem conteúdo.",
  "error.not.found": "Página não encontrada.",
  "error.not.implemented": "Funcionalidade não implementada.",
  "error.not.modified": "Requisição não modificada (caching).",
  "error.partial.content": "Requisição parcialmente atendida.",
  "error.precondition.failed": "Pré-condição falhou.",
  "error.processing": "Processamento (WebDAV) sendo executado em segundo plano.",
  "error.protocol.interaction": "Interação de protocolo (WebDAV).",
  "error.proxy.authentication": "Requer autenticação de proxy.",
  "error.redirect": "Redirecionando (manter o método original).",
  "error.requested.range.not.satisfiable": "Faixa de solicitação não atendida.",
  "error.seeOther": "Consulte outra URI. Redirecionando...",
  "error.service.unavailable": "Serviço indisponível. Tente novamente mais tarde.",
  "error.session.expired": "Sessão Expirada",
  "error.success.request": "Requisição bem-sucedida.",
  "error.teapot": "Sinto muito, sou uma xícara de chá.",
  "error.too.many.requests": "Muitos pedidos.",
  "error.unauthorized": "Não autorizado. Faça login para acessar.",
  "error.unexpected.Response.message": "Recebemos uma resposta inesperada do servidor. Tente novamente mais tarde.",
  "error.unexpected.Response": "Resposta Inesperada",
  "error.unknown": "Erro Desconhecido",
  "module.download": "Baixar",
  "module.info.download": "Por favor, faça o download e execute-o e em seguida, clique em Recarregar a Página.",
  "module.notfound": "Parece que você ainda não possui o módulo: ",
  "warning.unsupported.Browser.message": "Por favor, atualize seu navegador para uma versão mais recente para uma melhor experiência de usuário.",
  "warning.unsupported.Browser": "Navegador não suportado",
  "warningPage.subTitle": "Desculpe, esta página não está disponível em telas menores que 600px.",
  "warningPage.title": "Tela Muito Pequena",
}

export default ptBR;